<template>
  <BaseButton :class="$style.button">
    <IconSelect
      icon="favorites"
      :class="$style['favorites-icon']"
      :icon-props="{ fill: 'currentColor' }"
      :height="defaultIconSize"
      :width="defaultIconSize"
    />

    <IconSelect
      :class="$style['menu-icon']"
      :icon="icon"
      :height="defaultIconSize"
      :width="defaultIconSize"
    />
  </BaseButton>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'QuickfinderButton',
  components: {
    IconSelect,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultIconSize: 24,
    }
  },
  computed: {
    icon() {
      return this.isActive ? 'close' : 'menu'
    },
  },
}
</script>

<style lang="scss" module>
.button {
  z-index: 3;

  width: auto !important;
  min-width: 2.5rem !important;
  height: auto !important;
  min-height: unset;
  padding: 0.5rem !important;

  :global(.v-btn__content) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.favorites-icon {
  margin-bottom: 0.75rem;

  color: var(--white);

  fill: currentColor;
  stroke: currentColor;
}

.menu-icon {
  color: var(--black);
}
</style>
